@if (isEmptyResult || needToShowEmptyState()) {
  <!-- Empty State -->
  <div class="empty-search flex-center flex-column">
    <app-st-icon style="font-size: 48px" [color]="'#A8A8A8'"
                 [bold]="true" name="search_off"></app-st-icon>
    <p class="text-label-12">No hay {{isEmptyResult ? 'resultados de búsqueda' : entity}} para <strong>“{{ searchvalue }}”</strong></p>
  </div>
} @else {
  <div class="flex flex-column gap-300">

    <div class="flex flex-column gap-100" *ngIf="serviceOrders.length > 0 && showServiceOrders">
      <span class="text-label-12">Órdenes de servicio</span>
      @for (so of serviceOrders; track so.id) {
        <app-global-search-result-card [serviceOrder]="so"
                                       [searchvalue]="searchvalue"
                                       [isSmallMode]="isSmallMode"></app-global-search-result-card>
      }

      <a *ngIf="isSmallMode && thereIsMoreServiceOrdersToShown"
         [routerLink]="['/search']">Ver más órdenes de servicio para
        <span>“{{ searchvalue }}”</span></a>
    </div>

    <div class="flex flex-column gap-100" *ngIf="services.length > 0 && showServices">
      <span class="text-label-12">Servicios</span>
      @for (service of services; track service.id) {
        <app-global-search-result-card [service]="service"
                                       [searchvalue]="searchvalue"
                                       [isSmallMode]="isSmallMode"></app-global-search-result-card>
      }

      <a *ngIf="isSmallMode && thereIsMoreServicesToShown"
         [routerLink]="['/search']">Ver más servicios para <span>“{{ searchvalue }}
        ”</span></a>
    </div>

    <div class="flex flex-column gap-100" *ngIf="projects.length > 0 && showProjects">
      <span class="text-label-12">Proyectos</span>
      @for (project of projects; track project.id) {
        <app-global-search-result-card [project]="project"
                                       [searchvalue]="searchvalue"
                                       [isSmallMode]="isSmallMode"></app-global-search-result-card>
      }

      <a *ngIf="isSmallMode && thereIsMoreProjectsToShown"
         [routerLink]="['/search']">Ver más proyectos para <span>“{{ searchvalue }}”</span></a>
    </div>

    @if (isSmallMode) {
      <nz-divider style="margin: 0" nzType="horizontal"></nz-divider>

      <a [routerLink]="['/search']" style="font-weight: 600; margin: auto">Ver todos los
        resultados</a>
    }
  </div>
}
